import styled from '@emotion/styled';
import { BaseInput, CollapsibleContainer, Variables } from '../../base';

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    flex-wrap: wrap;
`;

export const SearchField = styled(BaseInput)`
    flex: 1;
    min-width: 240px;
    max-width: 380px;
`;

export const DosGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

export const DosLabel = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: ${Variables.Colors.n70};
    text-transform: uppercase;
    letter-spacing: 0.04em;
`;

export const ResultNote = styled.div`
    margin-left: auto;
    font-size: 13px;
    color: ${Variables.Colors.n50};
`;

export const CardList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
`;

export const ClaimCollapsible = styled(CollapsibleContainer)`
    border: 1px solid ${Variables.Colors.n30};
    border-radius: 12px;
    box-shadow: 0 1px 2px ${Variables.Colors.nx4};
    padding: 0;
    margin: 0;
    overflow: hidden;
    background: ${Variables.Swatches.White};

    > div:first-of-type {
        padding: 16px 20px;
        flex-direction: row-reverse;
        justify-content: flex-start;
        gap: 14px;
        align-items: center;
    }

    > div:last-of-type {
        margin-top: 0;
    }
`;

export const HeadContent = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1;
    min-width: 0;
`;

export const HeadMain = styled.div`
    min-width: 0;
    flex: 1;
`;

export const HeadTitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
`;

export const ClaimNumber = styled.span`
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
    color: ${Variables.Colors.n100};
`;

export const HeadMeta = styled.div`
    margin-top: 3px;
    font-size: 12px;
    color: ${Variables.Colors.n50};
`;

export const HeadBalance = styled.div`
    margin-left: auto;
    text-align: right;
`;

export const BalanceLabel = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: ${Variables.Colors.n50};
    text-transform: uppercase;
    letter-spacing: 0.04em;
`;

export const BalanceValue = styled.div<{ emphasis?: boolean }>`
    font-size: 18px;
    font-weight: 600;
    line-height: 1.1;
    font-variant-numeric: tabular-nums;
    color: ${props => (props.emphasis ? Variables.Colors.sunset500 : Variables.Colors.n100)};
`;

export const CardBody = styled.div`
    border-top: 1px solid ${Variables.Colors.n30};
    display: grid;
    grid-template-columns: 1.55fr 1fr;

    @media (max-width: 960px) {
        grid-template-columns: 1fr;
    }
`;

export const ServicesPanel = styled.div`
    padding: 18px 20px;
    border-right: 1px solid ${Variables.Colors.n30};

    @media (max-width: 960px) {
        border-right: none;
        border-bottom: 1px solid ${Variables.Colors.n30};
    }
`;

export const SettlementPanel = styled.div`
    padding: 18px 20px;
    background: color-mix(in srgb, ${Variables.Colors.b300} 6%, ${Variables.Swatches.White});
`;

export const SectionLabel = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: ${Variables.Colors.n70};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 10px;
`;

export const ServiceLine = styled.div`
    display: flex;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid ${Variables.Colors.n15};

    &:last-child {
        border-bottom: none;
    }
`;

export const ServiceMain = styled.div`
    min-width: 0;
    flex: 1;
`;

export const ServiceTitle = styled.div`
    font-size: 14px;
    color: ${Variables.Colors.n100};
`;

export const ServiceCharge = styled.span`
    flex: none;
    font-size: 14px;
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    color: ${Variables.Colors.n100};
`;

export const FlowList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const FlowRow = styled.div<{ dividerTop?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 7px 0;
    border-top: ${props => (props.dividerTop ? `1px solid ${Variables.Colors.n30}` : 'none')};
    margin-top: ${props => (props.dividerTop ? '4px' : '0')};
    padding-top: ${props => (props.dividerTop ? '11px' : '7px')};
`;

export const FlowLabel = styled.span<{ emphasized?: boolean }>`
    font-size: ${props => (props.emphasized ? '14px' : '13px')};
    font-weight: ${props => (props.emphasized ? 600 : 400)};
    color: ${props => (props.emphasized ? Variables.Colors.n100 : Variables.Colors.n70)};
`;

export const Empty = styled.div`
    padding: 48px 20px;
    text-align: center;
    background: ${Variables.Swatches.White};
    border: 1px dashed ${Variables.Colors.n30};
    border-radius: 12px;
    color: ${Variables.Colors.n70};
    font-size: 14px;
`;
